import React from 'react';
import './stylesheets/ActionButton.css';
import { Video } from 'lucide-react';

const ActionButton = ({ iconPath, text, onClick, color = "#2B7CB8", fontSize = '16px', width = "100%", padding = "14px 28px", disabled = false, hidden = false, className = '' }) => {
    const buttonStyle = {
        fontSize: fontSize,
        backgroundColor: color,
        width: width,
        padding: padding
    };

    let Icon;
    switch (iconPath) {
        case 'Video':
            Icon = <Video size={18} style={{ color: 'white', marginRight: '8px' }} />;
            break;
        default:
            Icon = null;
    }

    return (
        <button className={`action-button ${className}`} style={buttonStyle} onClick={onClick} disabled={disabled} hidden={hidden}>
            {/* Display the icon if it is not null */}
            {Icon}
            {text}
        </button>
    );
};

export default ActionButton;
